export default __webpack_public_path__ + "static/trade-500d8ffa328d165f9b36a327296f4846.svg";